export function getEditFormConfig() {
	return {
		FACET5: [
			{
				el: "el-input",
				label: "名称",
				name: "name",
				attrs: {
					placeholder: "请输入名称",
				},
			},
			{
				el: "rich-text",
				label: "标题",
				name: "title",
				attrs: {
					keyWord: "title",
					params: "",
				},
				show: {
					key: "innerVisible",
				},
			},
			{
				el: "rich-text",
				label: "维度解析",
				name: "descr",
				attrs: {
					keyWord: "descr",
					params: "",
				},
				show: {
					key: "innerVisible",
				},
			},
		],
		FBB: [
			{
				el: "el-input",
				label: "等级",
				name: "title",
				attrs: {
					clearable: true,
					placeholder: "请输入等级",
				},
			},
			{
				el: "rich-text",
				label: "定义",
				name: "content",
				attrs: {
					keyWord: "content",
					params: "",
				},
				show: {
					key: "innerVisible",
				},
			},
			{
				el: "rich-text",
				label: "偏差解读",
				name: "descr",
				attrs: {
					keyWord: "descr",
					params: "",
				},
				show: {
					key: "innerVisible",
				},
			},
			{
				el: "rich-text",
				label: "投资表现",
				name: "suggest",
				attrs: {
					keyWord: "suggest",
					params: "",
				},
				show: {
					key: "innerVisible",
				},
			},
		],
		IBB: [
			{
				el: "el-input",
				label: "等级",
				name: "title",
				attrs: {
					clearable: true,
					placeholder: "请输入等级",
				},
			},
			{
				el: "rich-text",
				label: "定义",
				name: "content",
				attrs: {
					keyWord: "content",
					params: "",
				},
				show: {
					key: "innerVisible",
				},
			},
			{
				el: "rich-text",
				label: "偏差解读",
				name: "descr",
				attrs: {
					keyWord: "descr",
					params: "",
				},
				show: {
					key: "innerVisible",
				},
			},
			{
				el: "rich-text",
				label: "投资表现",
				name: "suggest",
				attrs: {
					keyWord: "suggest",
					params: "",
				},
				show: {
					key: "innerVisible",
				},
			},
		],
	};
}

export function getColumnConfig() {
	return {
		FACET5: [
			{
				el: "el-table-column",
				label: "名称",
				name: "name",
				attrs: {
					width: "140",
					align: "center",
				},
			},
			{
				el: "el-table-column",
				label: "标题",
				name: "title",
				attrs: {
					width: "140",
					align: "center",
					html: true,
				},
			},
			{
				el: "el-table-column",
				label: "维度解析",
				name: "descr",
				attrs: {
					width: "140",
					align: "center",
					html: true,
				},
			},
		],
		FBB: [
			{
				el: "el-table-column",
				label: "等级",
				name: "title",
				attrs: {
					width: "140",
					align: "center",
				},
			},
			{
				el: "el-table-column",
				label: "定义",
				name: "content",
				attrs: {
					width: "140",
					align: "center",
					html: true,
				},
			},
			{
				el: "el-table-column",
				label: "偏差解读",
				name: "descr",
				attrs: {
					width: "140",
					align: "center",
					html: true,
				},
			},
			{
				el: "el-table-column",
				label: "投资表现",
				name: "suggest",
				attrs: {
					width: "140",
					align: "center",
					html: true,
				},
			},
		],
		IBB: [
			{
				el: "el-input",
				label: "等级",
				name: "title",
				attrs: {
					width: "140",
					align: "center",
				},
			},
			{
				el: "el-table-column",
				label: "定义",
				name: "content",
				attrs: {
					width: "140",
					align: "center",
					html: true,
				},
			},
			{
				el: "el-table-column",
				label: "偏差解读",
				name: "descr",
				attrs: {
					width: "140",
					align: "center",
					html: true,
				},
			},
			{
				el: "el-table-column",
				label: "投资表现",
				name: "suggest",
				attrs: {
					width: "140",
					align: "center",
					html: true,
				},
			},
		],
	};
}
